__webpack_require__.p = "https://kolo-django-dev.s3.amazonaws.com/";